import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { Eye, EyeOff } from "lucide-react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [no_tlpn, setNo_tlpn] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorConfirm, setErrorConfirm] = useState("");

  const isFormValid = () => {
    return email && password;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, password, password_confirmation, no_tlpn }),
      });

      if (!res.ok) {
        throw new Error("Register gagal");
      }

      const data = await res.json();

      if (data?.token) {
        // simpan token di cookie (1 hari, secure untuk https)
        Cookies.set("token", data.token, { expires: 1, secure: true });

        // redirect ke page utama
        navigate("/pageutama");
      }
    } catch (error: any) {
      console.error(error);
      alert("Login gagal, periksa email/password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* background putih gradiasi emas */}
      <div className="bg-gradient-to-b from-white to-[#cfa84d] mx-auto flex justify-center min-h-screen">
        <div className="px-7 py-5 rounded-lg w-full md:mx-8 lg:mx-20 max-w-md  h-full my-auto">
          {/* <Link to="/">
            <div className="flex justify-start">
              <div className="bg-[#cfa84d] text-white px-3 py-3 rounded-full shadow">
                <img src="/logo/back.png" alt="" className="w-5 h-5" />
              </div>
            </div>
          </Link> */}

          <div className="flex justify-center my-3">
            <img src="/images/pancasila.png" alt="" className="w-20 h-24" />
          </div>

          <h1 className="text-3xl md:text-4xl mt-4 mb-8 text-center font-bold text-[#cfa84d]">
            Registrasi <span className="text-gray-700">User</span>
          </h1>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Nama</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan Nama" />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan Email" />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">No Telepon / WhatsApp</label>
              <input type="text" className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan No Telepon / WhatsApp" value={no_tlpn} onChange={(e) => setNo_tlpn(e.target.value)} />
            </div>

            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-700 font-semibold">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 pr-10"
                placeholder="Masukan Password"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-11 text-[#cfa84d]">
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-700 font-semibold">Konfirmasi Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password_confirmation}
                onChange={(e) => {
                  setPassword_confirmation(e.target.value);
                  if (e.target.value !== password) {
                    setErrorConfirm("Password konfirmasi belum sama");
                  } else {
                    setErrorConfirm("");
                  }
                }}
                className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 pr-10"
                placeholder="Masukan Konfirmasi Password"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-11 text-[#cfa84d]">
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>

              {/* Tampilkan error realtime */}
              {errorConfirm && <p className="text-red-500 text-sm mt-1">{errorConfirm}</p>}
            </div>

            <div className="flex justify-end mt-2 ">
              <button
                type="submit"
                disabled={!isFormValid() || loading}
                className={`py-2 px-8 rounded-lg text-white text-center transition-all w-full cursor-pointer ${
                  !isFormValid() || loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#cfa84d] hover:bg-white hover:text-[#cfa84d] border border-[#cfa84d]"
                }`}>
                {loading ? "Loading..." : "Daftar"}
              </button>
            </div>

            <div className="text-gray-700 text-center ">
              Sudah Punya Akun ?{" "}
              <span className="font-bold">
                <Link to={"/register"}>Login</Link>
              </span>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;
